import { Component, EventEmitter, Input, Output } from '@angular/core';
import * as Sentry from '@sentry/angular';
import { MatDialog } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { GeofencesService } from 'src/app/features/map-features/sections/geofences-section/services/Geofences.service';
import { PanelAddGeofencesService } from 'src/app/features/map-features/sections/geofences-section/services/Panel-Add-Geofences.service';
import { PanelDetailLocationsService } from 'src/app/features/map-features/sections/locations-section/services/Panel-Detail-Locations.service';
import { ValetParkingService } from 'src/app/features/map-features/sections/locations-section/services/ValetParking.service';
import { GroupStepRouteDTO } from 'src/app/features/map-features/sections/route-section/models/GroupStepRouteDTO';
import { IRouteMapRequest } from 'src/app/features/map-features/sections/route-section/models/IRouteMapRequest';
import { ResumeRouteMapDTO } from 'src/app/features/map-features/sections/route-section/models/ResumeRouteMapDTO';
import { StepDetailsRouteDTO } from 'src/app/features/map-features/sections/route-section/models/StepDetailsRouteDTO';
import { PanelResumeRouteService } from 'src/app/features/map-features/sections/route-section/services/Panel-Resume-Route.service';
import { RouteFilterService } from 'src/app/features/map-features/sections/route-section/services/Route-Filter.service';
import { RouteMapService } from 'src/app/features/map-features/sections/route-section/services/RouteMap.service';
import { MapHelperService } from 'src/services/map-helper.service';
import { LocationsService } from 'src/app/features/map-features/sections/locations-section/services/Locations.service';
import { LocationsMapService } from 'src/app/features/map-features/sections/locations-section/services/LocationsMap.service';
import { environment } from "src/environments/environment";
import { FilterMapComponent } from 'src/app/features/map-features/sections/locations-section/components/2-panel-locations/organisms/filters/filters-map/filter-map.component';
import { LocationDTO } from 'src/app/features/map-features/sections/locations-section/models/LocationDTO';
import { GeoClustersFrecuencyPlacesService } from 'src/app/features/map-features/sections/locations-section/services/GeoClustersFrecuencyPlaces.service';
import { PanelLocationsService } from 'src/app/features/map-features/sections/locations-section/services/Panel-Locations.service';
import { PopupReportHistorialService } from 'src/app/features/map-features/sections/locations-section/services/Popup-Report-Historial.service';
import { EstatusJSON } from 'src/app/features/shared/models/EstatusJSON';
import { LocalStorageService } from 'src/app/features/shared/services/LocalStorage.service';
import { NotificationsToastService } from 'src/app/features/shared/services/Notifications-Toast.service';
import { AssignmentService } from 'src/app/features/shared/services/ServiceCatalogEncapsulators/Assigment.service';
import { CitronellaActionsService } from 'src/app/features/shared/services/ServiceCatalogEncapsulators/CitronellaActions.service';
import { SignalUserService } from 'src/app/features/shared/services/ServiceCatalogEncapsulators/Signal-User.service';
import { SessionService } from 'src/app/features/shared/services/Session.service';
import { SwalNotificationService } from 'src/app/features/shared/services/SwalNotification.service';
import { CarouselPopupComponent } from '../../../../../../ui/atoms/carousel-popup/carousel-popup.component';
import { ConfirmDialogService } from '../../../../../../ui/atoms/dialogs/confirm-dialog/services/Confirm-Dialog.service';
import { MessageDialogService } from '../../../../../../ui/atoms/dialogs/message-dialog/services/message-dialog.service';
import { IRequestMapRouteForm } from '../../../report-list/models/IRequestMapRouteForm';
import { AllowedDTO } from 'src/app/features/pages/maps/utils/models/allowedDTO';
import { DetailsPanelAllowanceEnum } from 'src/app/features/pages/maps/utils/enums/detailsPanelAllowanceEnum';
import { MapRestrictionsService } from 'src/app/features/pages/maps/services/MapRestrictions.service';
import { PanelInternalLayerService } from 'src/app/features/map-features/sections/locations-section/services/Panel-Internal-Layer.service';
import { ReportsService } from 'src/app/features/shared/services/ServiceCatalogEncapsulators/Reports.service';
import { ExcelUtilities, ReportExcelCellValue } from 'src/app/features/shared/helpers/utilities/ExcelUtilities';
import { ReportTabExcelDTO } from 'src/app/features/map-features/sections/locations-section/models/ReportTabExcelDTO';
import { PopupUpdateVirtualLocationComponent } from 'src/app/features/map-features/ui/molecules/popup-update-virtual-location/popup-update-virtual-location.component';
import { VirtualDataLocationDTO, VirtualLocationDTO } from 'src/app/features/map-features/ui/organisms/route-sheet/models/VirtualLocationDTO';
import { PopupUpdateLocationComponent } from 'src/app/features/map-features/ui/molecules/popup-update-location/popup-update-location.component';
import { LocationCategoryDTO } from 'src/app/features/map-features/sections/locations-section/models/LocationCategoryDTO';
import { DataNamesDTO } from 'src/app/features/map-features/sections/locations-section/models/DataNamesDTO';
import { FilterDialogData, FilterDialogResult } from "src/app/features/map-features/sections/locations-section/models/Filters";

@Component({
  selector: 'location-button-toolbar',
  templateUrl: './location-button-toolbar.component.html',
  styleUrls: ['./location-button-toolbar.component.css']
})
export class LocationButtonToolbarComponent {
  
  //restricciones
  allowedParts: AllowedDTO;
  isTrazabilityAllowed: boolean = false;


  private _CENTER_LAT = "24.226252";
  private _CENTER_LNG = "-103.0266765";
  private _CENTER_ZOOM = "4.5";
  detailsPanelAllowanceEnum = DetailsPanelAllowanceEnum;

  //Hardcodeado para branding e ingenieros
  isBranding : boolean = false;
  hasServiceAsignation : boolean = false;
  @Output() valetParkingDeleteResponse = new EventEmitter<boolean>();

  isLoadingButton: boolean = false;
  @Input() isLoadingParent: boolean = false;

  //output para accion de cargar
  @Output() loadEmiter = new EventEmitter<boolean>();

  //inputs para modificar opciones de herramientas
  @Input() isGlobal: boolean = false;
  @Input() identifier: any;
  @Input() description: any;
  @Input() isFromLocation: boolean = false;
  

  //inputs para la lista de excel
  @Input() btnDownExcel: boolean = false;
  @Input() isLocationFilter: boolean = false;
  @Input() panelGlobalFinder: string = "";
  @Input() globalFilterIdentifiers: string[] = [];
  @Input() excelDownloadOperation: string;
  @Input() idLocationCategory: number;

  //inputs y outputs para el filtro
  @Input() showFilter: boolean = true;
  @Input() filtersObject: FilterDialogData;
  @Input() ApplyFilter: boolean = false;
  // @Input() AvailabilityFiltersObject: any;
  // @Input() ApplyAvailabilityFilter: boolean = false;
  @Output() filterResponse = new EventEmitter<any>();
  // @Output() availabilityFilterResponse = new EventEmitter<any>();

  //inputs para valet parking
  @Input() hasValetParking: boolean = false;
  @Input() isValetParking: boolean = false;
  @Input() valetParkingGuid: string = "";
  @Output() valetParkingCreateResponse = new EventEmitter<any>();

  //inputs para geocercas
  @Input() isGeofencePanel: boolean = false;
  @Input() isGeofenceDetails: boolean = false;
  @Input() geofenceGuid: string = "";

  //inputs para routes
  locationRequest: any = {
    identifier: undefined,
    startDate: new Date(),
    endDate: new Date(),
  };
  @Input() isDetailLocations: boolean = false;
  @Input() isMonitor: boolean = true;
  @Input() images: string[] = [];
  @Input() isLoadingImages: boolean = false;
  @Input() hasRouteTrace: boolean = true;


  //inputs para Bloqueo
  @Input() blockingObject: { isVisibleBlocking: boolean, blockingIcon: string};

  //inputs para streetView
  @Input() CordX: string = "";
  @Input() CordY: string = "";

  //para recargar panel de detalles
  @Input() isReloadable: boolean = false;
  
  @Output() refreshRequested = new EventEmitter<void>();

  //para mostrar como lista vertical
  @Input() isVerticalList: boolean = false;

  //para crear ticket de citronella
  @Input() openCitronellaTicket: boolean = false;
  @Input() location: LocationDTO;

  //para editar datos de una ubicación virtual (prospecto)
  @Input() locationKeys: string[] = [];
  @Input() locationValues: string[] = [];
  @Input() editKeyNames: DataNamesDTO[] = [];
  @Input() mobileQuery: MediaQueryList;
  @Output() locationUpdated = new EventEmitter<any>();
  editDialogRef: any;

  private editableCategory: LocationCategoryDTO = null;
  private editableCategoryResolvedFor: number = null;

  suscription_postLocationsToExcel: Subscription;
  Subscription_AfterClosed: Subscription;
  subscription_findByIdentifier: Subscription;
  subscription_routeFilterService: Subscription;
  suscription_createBlokingRequest: Subscription;
  suscription_delete: Subscription;
  suscription_confirmDialogService: Subscription;
  suscription_valetParkingDelete: Subscription;
  suscription_OpenCitornellaTicket: Subscription;

  constructor(
    private popupReportHistorialService: PopupReportHistorialService,
    private reportsService: ReportsService,
    private notifyService: SwalNotificationService,
    private sessionService: SessionService,
    public dialog: MatDialog,
    private panelLocationsService: PanelLocationsService,
    private locationService: LocationsService,
    private panelDetalilService: PanelDetailLocationsService,
    private routeFilterService: RouteFilterService,
    private routeMapService: RouteMapService,
    private panelResumeRouteService: PanelResumeRouteService,
    private mapHelper: MapHelperService,
    private signalUserService: SignalUserService,
    private locationsMapService: LocationsMapService,
    private valetParkingService: ValetParkingService,
    private geofenceService: GeofencesService,
    private panelAddGeofenceService: PanelAddGeofencesService,
    private confirmDialogService: ConfirmDialogService,
    private citronellaActionsService: CitronellaActionsService,
    private messageDialogService: MessageDialogService,
    private panelGeofenceDetailService: PanelDetailLocationsService,
    public geoClustersFrecuencyCatalogService: GeoClustersFrecuencyPlacesService,
    private notifyToastService: NotificationsToastService,
    private assignmentService: AssignmentService,
    private mapRestrictionsService: MapRestrictionsService,
    private localStorageService: LocalStorageService,
    private panelInternalLayerService: PanelInternalLayerService) {
      if(this.sessionService.Customer == undefined || this.sessionService.Customer == null)         
        this.sessionService.getCustomerId();
      this.blockingObject = { isVisibleBlocking: false, blockingIcon: "lock" };

      if(this.localStorageService.getClienteSeleccionadoId() == "26797ce1-d5b1-4446-8fdb-8967ee7c3ad5"){
        this.isBranding = true;
      };

      if(true){
        this.hasServiceAsignation = true;
      };
    }

    ngOnInit(): void {
      this.calculateRestrictions();
    }

    ngOnDestroy() {
      if (this.suscription_postLocationsToExcel)
        this.suscription_postLocationsToExcel.unsubscribe();
      if (this.suscription_confirmDialogService)
        this.suscription_confirmDialogService.unsubscribe();
      if (this.Subscription_AfterClosed)
        this.Subscription_AfterClosed.unsubscribe();
      if (this.subscription_findByIdentifier)
        this.subscription_findByIdentifier.unsubscribe();
      if (this.subscription_routeFilterService)
        this.subscription_routeFilterService.unsubscribe();
      if (this.suscription_createBlokingRequest)
        this.suscription_createBlokingRequest.unsubscribe();
      if (this.suscription_delete)
        this.suscription_delete.unsubscribe();
      if (this.suscription_valetParkingDelete)
        this.suscription_valetParkingDelete.unsubscribe();
      if (this.suscription_OpenCitornellaTicket)
        this.suscription_OpenCitornellaTicket.unsubscribe();

      if (this.editDialogRef) {
        this.editDialogRef.close();
        this.editDialogRef = null;
      }

      // this.geoClustersFrecuencyCatalogService.isRecurrentPlacesVisible = false;
      // this.geoClustersFrecuencyCatalogService.identifierRecurrentPlaces = "";
    }

  // duplicado de report-list temporal (?) para pruebas

  getTabExcel(){
    const categoryName = JSON.parse(this.localStorageService.getListaCategorias()).find(c => c.id == this.idLocationCategory)?.shortName;
    const categoryString = categoryName ? `de tipo ${categoryName}` : `de tipo ${this.excelDownloadOperation}`;
    const title = this.isLocationFilter ? `Descargar excel de locaciones filtradas` : categoryString;
    this.notifyService.customConfirmMessageInPanel(title, "Seguro que quieres descargar la lista de activos en excel?").then((result) => {
      if (result.value) {
        this.ShowDownloadingMessage();
        const excelObservable = this.isLocationFilter
          ? this.reportsService.postLocationsByIdentifiersToExcel(this.globalFilterIdentifiers)
          : this.reportsService.postLocationsTabToExcel(this.excelDownloadOperation, this.idLocationCategory, this.panelGlobalFinder, this.filtersObject.selected);

        this.suscription_postLocationsToExcel = excelObservable.subscribe({
          next: (data) => {
            if (data.isSuccess == true) {
              this.exportLocationsTabReportToExcel(data.result as ReportTabExcelDTO[], this.excelDownloadOperation);
            }
            else{
              Sentry.captureMessage('LocationButtonToolbar.getTabExcel: descarga de tab sin datos', { level: 'warning', extra: { response: data } });
              this.notifyService.MessageError("Archivo no descargado, No hay datos");
            }
          },
          error: (error) => {
            // TODO marca para complete despues
            console.error('Error descargando excel de locaciones', error);
            this.notifyService.MessageError("Error al descargar el archivo");
          }
        });
      }
    });
  }

  exportLocationsTabReportToExcel(rows: ReportTabExcelDTO[], excelOperation: string): void {
    const header = ["Identificador", "Descripción", "Cordenadas", "Google Maps", "Ultima Actualizacion"];
    const data = rows.map(row => [
      row.identifier,
      row.description? row.description : 'N/A',
      `${ExcelUtilities.max6DecTruncate(row.cordsY)}, ${ExcelUtilities.max6DecTruncate(row.cordsX)}`,
      ExcelUtilities.getGoogleMapsURL(row.cordsY, row.cordsX),
      ExcelUtilities.parseDate(row.fechaUltimaActualizacion)
    ]) as ReportExcelCellValue[][];
    const title = `Reporte de ${excelOperation} - ${new Date().toISOString().slice(0, 10)}`;
  
    const cliente = this.sessionService.Customer.description || "Cliente Desconocido";
      
    ExcelUtilities.exportReportExcel(title, header, data, cliente);
  }

  openFilter(): void {
    if(!environment.production) console.log("filtersObject",this.filtersObject);
    
    let dialogRef = this.dialog.open(FilterMapComponent, {
      data: {
        moduleName: this.filtersObject.moduleName,
        filters: this.filtersObject.filters,
        selected: this.filtersObject.selected,
        idLocationCategory: this.filtersObject.idLocationCategory,
      } as FilterDialogData,
      disableClose: false,
      panelClass: 'locations-filters-custom-popup',
      hasBackdrop: true,
      autoFocus: false,
      restoreFocus: false,
    });
    this.Subscription_AfterClosed = dialogRef.afterClosed().subscribe((res: FilterDialogResult) => {
      if (res.search) {
        this.filterResponse.emit(res);
      }
    });
  }

  getLocationRoute() {
    this.isLoadingButton = true;
    if(!environment.production) console.log("buscando...");

    this.locationRequest.identifier = this.identifier;
    this.locationRequest.startDate = new Date();
    this.locationRequest.endDate = new Date();
    if(!environment.production) console.log("request vehiculo identifier", this.locationRequest);
  
    if (
      this.locationRequest.identifier &&
      this.locationRequest.startDate &&
      this.locationRequest.endDate
    ) {
        try {
          const startDate = new Date(this.locationRequest.startDate);
          const endDate = new Date(this.locationRequest.endDate);
          startDate.setHours(this.locationRequest.startDate.getHours() - 6);
          startDate.setDate(this.locationRequest.startDate.getDate() - 1);
          endDate.setHours(this.locationRequest.endDate.getHours() - 6);
          var requestRouteMap: IRouteMapRequest = {
            Identifier: this.locationRequest.identifier,
            StartDate: startDate.toISOString(),
            EndDate: endDate.toISOString(),
            StartHour: null,
          };
  
          if(!environment.production) console.log("updating...");
  
          this.getRouteMapService(requestRouteMap);
        } catch (error) {
          // this.request.startDate = null;
          if(!environment.production) console.log(error);
          this.isLoadingButton = false;
        }
      }else{
        this.isLoadingButton = false;
      }

  //   this.subscription_findByIdentifier = this.locationService.findByIdentifier(this.identifier).subscribe({
  //     next: (arg) => {
  //     if (this.identifier.length == 17) {
  //       this.locationRequest.vehiculo = arg.result[0];
  //       this.routeFilterService.setVehiculo( arg.result[0]);
  //     }
  //     if(!environment.production) console.log("buscando...");

  //     this.locationRequest.startDate = new Date();
  //     this.locationRequest.endDate = new Date();
  //     if(!environment.production) console.log("request vehiculo identifier", this.locationRequest);
  
  //     if (
  //       this.locationRequest.vehiculo &&
  //       this.locationRequest.startDate &&
  //       this.locationRequest.endDate
  //     ) {
  //       try {
  //         const startDate = new Date(this.locationRequest.startDate);
  //         const endDate = new Date(this.locationRequest.endDate);
  //         startDate.setHours(this.locationRequest.startDate.getHours() - 6);
  //         startDate.setDate(this.locationRequest.startDate.getDate() - 1);
  //         endDate.setHours(this.locationRequest.endDate.getHours() - 6);
  //         var requestRouteMap: IRouteMapRequest = {
  //           Identifier: this.locationRequest.vehiculo.identifier,
  //           StartDate: startDate.toISOString(),
  //           EndDate: endDate.toISOString(),
  //           StartHour: null,
  //         };
  
  //         if(!environment.production) console.log("updating...");
  
  //         this.getRouteMapService(requestRouteMap);
  //       } catch (error) {
  //         // this.request.startDate = null;
  //         if(!environment.production) console.log(error);
  //         this.isLoadingButton = false;
  //       }
  //     }else{
  //       this.isLoadingButton = false;
  //     }
  //   },
  //   error: (error) => {
  //     // TODO marca para complete despues
  //     console.error('Error encontrando locacion (rutas)', error);
  //     this.isLoadingButton = false;
  //   }
  // });
            
    
  }

  getRouteMapService(routeMapRequest: IRouteMapRequest) {

    this.subscription_routeFilterService = this.routeFilterService.getRouteData(routeMapRequest).subscribe({
      next: (resp) => {
        if (resp.isSuccess) {
          var resumeRoute = resp.result.resumeRouteMapDTO as ResumeRouteMapDTO;
          var detailsRoute = resp.result
            .detailsRouteDTO as StepDetailsRouteDTO[];
          var groupedRoute = resp.result
            .groupStepsRouteDTO as GroupStepRouteDTO[];
          if (resumeRoute != null) {
            
            if (resumeRoute.cantStops != null && resumeRoute.cantStops != "0" ) {
              //Close Locations
              this.isLoadingButton = false;
              this.panelLocationsService.setVisibilityPanel(false);
              this.panelDetalilService.setVisibilityPopup(false);
              //this.signalUserService.UnsubscribeSignalUserIdentifierService(this.identifier);
              this.mapHelper.UpdateLayerGeoJson(
                "locationActiveSource",
                this.mapHelper.Empty_GeoJson
              );

              //open routes
              this.routeMapService.showRouteMapLayers();
              this.panelResumeRouteService.setVisibilityPopup(true);
              this.panelResumeRouteService.setResume(resumeRoute);
              this.panelResumeRouteService.setDetails(detailsRoute);
              this.panelResumeRouteService.setGrouped(groupedRoute);
              if(!environment.production) console.log("groupedRoute", groupedRoute);
              this.mapHelper.SetBounds(JSON.parse(resumeRoute.sGeojsonResume));
              //this.panelResumeRouteService.setRequest(request);
              this.routeMapService.updateRouteMap(resumeRoute.sGeojsonResume);
            } else {
              
              this.isLoadingButton = false;
              this.notifyToastService.showInfo(
                "por favor acceda desde Rutas para filtrar por otro rango de fechas",
                "La Trazabilidad de Ruta para éste carro al día de ayer no fue encontrada"
              );
            }
          } else {
            
            this.isLoadingButton = false;
            this.notifyToastService.showInfo(
              "por favor acceda desde Rutas para filtrar por otro rango de fechas",
              "La Trazabilidad de Ruta para éste carro al día de ayer no fue encontrada"
            );
          }
        } else {
          Sentry.captureMessage('LocationButtonToolbar.getRouteMapService: ruta sin éxito', { level: 'warning', extra: { response: resp } });
          this.isLoadingButton = false;
          console.error('Error obteniendo datos de ruta', resp.message, resp.result);
          // this.toastrService.error("Internal Error", elements.errors.toString());
        }
      },
      error: (error) => {
        // TODO marca para complete despues
        console.error('Error obteniendo datos de ruta', error);
        this.isLoadingButton = false;
      }
    });
  }

  ValetParking(){
    if (this.isValetParking) {
      this.notifyService.confirmMessage("Eliminar", "Seguro que quieres eliminar el valet parking?").then((result) => {
        if (result.value) {
          this.suscription_valetParkingDelete = this.geofenceService.FullDelete(this.valetParkingGuid).subscribe({
            next: (data) => {
            if(data.isSuccess == true){
              this.notifyService.MessageSuccessful("Borrado","Valet Parking Borrado exitosamente");
              this.valetParkingDeleteResponse.emit(true);
            }else{
              Sentry.captureMessage('LocationButtonToolbar.ValetParking: eliminación sin éxito', { level: 'warning', extra: { response: data } });
              this.notifyService.MessageError("Problema al eliminar el Valet Parking");
              console.error('Error al eliminar valet parking', data.message, data.result);
            }
          },
          error: (error) => {
            // TODO marca para complete despues
            console.error('Error al eliminar valet parking', error);
            this.notifyService.MessageError("Error al eliminar el Valet Parking");
          }
        });
        }
      });
    }else{
      var dialog = this.valetParkingService.openDialog(this.identifier, this.description);
      dialog.afterClosed().subscribe((isCreated) => {
        if (isCreated)
          this.valetParkingCreateResponse.emit(isCreated);
      });
    }
  }

  OpenBlokingDialog() {
      const state = this.blockingObject.blockingIcon == "lock" ? "desbloqueo" : "bloqueo";
      const title = `Solicitud de ${state}`;
      const message = `¿Desea realizar una solicitud de '${state}' para el activo '${this.identifier}'?`;

      this.suscription_confirmDialogService = this.confirmDialogService.show(title, message).subscribe({
          next: (result) => {
          if (result) {
            this.isLoadingButton = true;
            this.suscription_createBlokingRequest = this.citronellaActionsService .createBlokingRequest(this.identifier) .subscribe({
                next: (data: EstatusJSON) => {
                this.messageDialogService.show(title, data.message);
                if (data.isSuccess) {
                  this.panelDetalilService.setBlokingIcon(data.result.locked);
                }else{
                  Sentry.captureMessage('LocationButtonToolbar.OpenBlokingDialog: bloqueo sin éxito', { level: 'warning', extra: { identifier: this.identifier, response: data } });
                  this.notifyService.MessageError("Problema al bloquear el auto, comuniquese con el administrador");
                  console.error('Error al bloquear el auto', data.message, data.result);
                }
                this.isLoadingButton = false;
              },
              error: (error) => {
                // TODO marca para complete despues
                console.error('Error al crear la solicitud de bloqueo de carro', error);
                this.notifyService.MessageError("Error al procesar la solicitud de bloqueo");
                this.isLoadingButton = false;
              }
            });
          }
        },
        error: (error) => {
          // TODO marca para complete despues
          console.error('Error con el dialogo de bloqueo de carro (?)', error);
        }
      });
  }

  private getEditableCategory(): LocationCategoryDTO {
    const idCategory = this.location?.idLocationCategory ?? this.idLocationCategory;
    if (!idCategory)
      return null;
    if (this.editableCategoryResolvedFor === idCategory)
      return this.editableCategory;

    this.editableCategoryResolvedFor = idCategory;
    const categories = JSON.parse(this.localStorageService.getListaCategorias() || "[]") as LocationCategoryDTO[];
    this.editableCategory = categories.find((category) => category.id == idCategory) ?? null;
    return this.editableCategory;
  }

  canEditLocation(): boolean {
    return !!this.location?.identifier && !!this.getEditableCategory()?.canBeEdited;
  }

  private buildVirtualLocationToEdit(): VirtualLocationDTO {
    return {
      id: 0,
      cords: null,
      idGroup: this.location.idGroup ?? 0,
      idSubGroup: this.location.idSubGroup ?? 0,
      idLocationCategory: this.location.idLocationCategory,
      guid: '',
      cordsX: this.location.cordsX,
      cordsY: this.location.cordsY,
      identifier: this.location.identifier,
      description: this.location.description,
      locationCategory: this.location.locationCategory,
      icon: this.location.panelIcon || this.location.icon,
      activeIcon: '',
      status: 1,
      data: this.locationKeys.map((key, index): VirtualDataLocationDTO => ({
        idOrder: index,
        key: key,
        value: this.locationValues[index],
        dataType: 'string'
      })),
      group: this.location.group,
      subGroup: this.location.subGroup,
      idLocationCategoryStatus: this.location.idLocationCategoryStatus ?? 0
    };
  }

  openEditLocationDialog() {
    const category = this.getEditableCategory();
    if (!category?.canBeEdited)
      return;

    const dialogConfig = {
      maxWidth: "98vw",
      maxHeight: "92vh",
      autoFocus: false,
      restoreFocus: false,
      hasBackdrop: false,
      disableClose: true
    };

    if (category.itWorksAsVirtualLocation) {
      this.editDialogRef = this.dialog.open(PopupUpdateVirtualLocationComponent, {
        ...dialogConfig,
        data: {
          locationDTO: this.buildVirtualLocationToEdit(),
          keyNames: this.editKeyNames,
          mobileQuery: this.mobileQuery
        }
      });
    } else {
      this.editDialogRef = this.dialog.open(PopupUpdateLocationComponent, {
        ...dialogConfig,
        data: {
          locationDTO: this.location,
          keys: this.locationKeys,
          values: this.locationValues,
          keyNames: this.editKeyNames,
          mobileQuery: this.mobileQuery
        }
      });
    }

    this.editDialogRef.afterClosed().subscribe((result) => {
      if (result?.isUpdated) {
        this.notifyToastService.showSuccess("Los cambios se guardaron correctamente", "Actualizado");
        this.locationUpdated.emit(result);
      }
    });
  }

  OpenTicket() {
    const title = `Solicitud de prospecto`;
    var message = `¿Desea realizar una solicitud de prospecto para el activo '${this.location.identifier}'?`;
    const userMail = this.localStorageService.getUser();

    this.suscription_OpenCitornellaTicket = this.confirmDialogService.show(title, message).subscribe({
      next: (result) => {
        if (result) {
          // this.isLoadingButton = true;
          // this.suscription_createBlokingRequest = this.citronellaActionsService.createProspectTicketRequest(this.location, userMail).subscribe({
          //   next: (data: EstatusJSON) => {
          //     this.messageDialogService.show(title, data.message);
          //     if (data.isSuccess) {
          //       //TODO: ver que hacer y/0 que trae la funcion
          //     } else {
          //       this.notifyService.MessageError("Problema al crear la solicitud de prospecto, comuniquese con el administrador");
          //       console.error('Error al crear la solicitud de prospecto', data.message, data.result);
          //     }
          //     this.isLoadingButton = false;
          //   },
          //   error: (error) => {
          //     console.error('Error al crear la solicitud de prospecto', error);
          //     this.notifyService.MessageError("Error al procesar la solicitud de prospecto");
          //     this.isLoadingButton = false;
          //   }
          // });
        }
      },
      error: (error) => {
        // console.error('Error con el dialogo de solicitud de prospecto', error);
      }
    });
  }

  onClickAddGeofence(){
    this.panelAddGeofenceService.$guidEditable = "";
    this.panelAddGeofenceService.$isDuplicate = false;
    this.geofenceService.setVisiblePanelGeofences(false);
    //selecciona el panel de agregar geocerca
    this.geofenceService.setVisiblePanelEditGeofences(true);
  }

  onClickEditGeofence(){
    this.panelAddGeofenceService.$guidEditable = this.geofenceGuid;
    this.panelAddGeofenceService.$isDuplicate = false;
    this.geofenceService.setVisiblePanelGeofences(false);
    this.geofenceService.setVisiblePanelDetailGeofences(false);
    //selecciona el componnte de edicion
    this.geofenceService.setVisiblePanelEditGeofences(true);
  }

  onClickDuplicateGeofence(){
    this.panelAddGeofenceService.$guidEditable = this.geofenceGuid;
    this.panelAddGeofenceService.$isDuplicate = true;
    this.geofenceService.setVisiblePanelGeofences(false);
    this.geofenceService.setVisiblePanelDetailGeofences(false);
    //selecciona el componente de edicion
    this.geofenceService.setVisiblePanelEditGeofences(true);
  }

  onClickDeleteGeofence(){
    var resp = this.notifyService.confirmMessage("Borrado","¿Seguro que desea borrar esta geocerca ?");
    resp.then((result) =>{
       if(result.value)
       {
          // window.open(urlb,'_blank');
          this.suscription_delete = this.geofenceService.delete(this.geofenceGuid).subscribe({
            next: (data) => {
            if(!environment.production) console.log("Data ",data);
            if(data.isSuccess == true){
              this.notifyService.MessageSuccessful("Borrado","Registro Borrado exitosamente");
              this.panelInternalLayerService.DeactivateLayer(this.panelInternalLayerService.geofenceLayer);
              this.panelInternalLayerService.ActivateLayer(this.panelInternalLayerService.geofenceLayer);
              this.OpenGeofencePanel();
              this.mapHelper.FlyToCamera( this._CENTER_LAT, this._CENTER_LNG, this._CENTER_ZOOM);
            }else{
              Sentry.captureMessage('LocationButtonToolbar.onClickDeleteGeofence: eliminación sin éxito', { level: 'warning', extra: { guid: this.geofenceGuid, response: data } });
              this.notifyService.MessageError("Problema al eliminar el registro");
            }
          },
          error: (error) => {
            // TODO marca para complete despues
            console.error('Error al eliminar geocerca', error);
            this.notifyService.MessageError("Error al eliminar el registro");
          }
        });
        }
     }); 
    // this.panelAddGeofenceService.$guidEditable = this.geofenceGuid;
    // this.geofenceService.deleteGeofence(this.geofenceGuid);
  }

  OpenGeofencePanel(){
    this.panelGeofenceDetailService.setVisibilityPopup(false);
    this.geofenceService.setVisiblePanelDetailGeofences(false);
    this.geofenceService.setVisiblePanelGeofences(false);
    setTimeout(() => {
      this.geofenceService.setVisiblePanelGeofences(true);
    }, 1000);
  }

  refreshDetails(){
    if (this.refreshRequested.observed) {
      this.refreshRequested.emit();
      return;
    }
    this.mapHelper.UpdateLayerGeoJson(
      "locationCarActiveSource",
      this.mapHelper.Empty_GeoJson
    );
    // this.routeSheetService.isForceReload = true;
    this.locationsMapService.onFocusPin(this.identifier, true);
  }

  // para popup de imagenes
  openCarouselPopup() {
    const diag = this.dialog.open(CarouselPopupComponent, {
      width: '60vw',
      height: 'fit-content',
      data: { 
        images: this.images,
        currentIndex: 0,
      },
      // panelClass: 'custom-dialog-container'
    });

    diag.backdropClick().subscribe(result => {
      diag.close();
    });
  }

  // para popup de imagenes
  openStreetView() {
    this.locationsMapService.loadStreetView(this.CordX, this.CordY);
  }

  ShowDownloadingMessage() {
    var resp = this.notifyService.MessageDownloading();
    resp.then(d=>{
      if(d.isConfirmed){
        this.notifyToastService.showInfoExtended("","Procesando solicitud de descarga...");
      }});
  }

  // para el componente de lugares recurrentes
  // openRecurrentPlaces(){
  //   this.geoClustersFrecuencyCatalogService.setRecurrentPlaces(!this.geoClustersFrecuencyCatalogService.isRecurrentPlacesVisible);
  //   if(this.geoClustersFrecuencyCatalogService.isRecurrentPlacesVisible){
  //     this.geoClustersFrecuencyCatalogService.identifierRecurrentPlaces = this.identifier;
  //   }else{
  //     this.geoClustersFrecuencyCatalogService.identifierRecurrentPlaces = "";
  //   }
  // }

 
  startAssignment(){
    this.notifyService.confirmMessage("Asignar servicios a los ingenieros", "Una vez se inicie el proceso, se bloquearan los controles hasta que termine, ¿Comenzar?").then((result) => {
      if (result.value) {
        this.assignmentService.GetLastCalculateAllEngineersUI().subscribe({
          next: (data: EstatusJSON) => {
          if (data.isSuccess && data.result != null) {
            this.notifyToastService.showWarning("Asignación de servicios","Iniciando el proceso de asignación de servicios");
            this.assignmentService.regionsGeometries = data.result.geoJsonRegions;
            this.assignmentService.zonesGeometries = data.result.geoJsonZones;
            this.assignmentService.clustersGeometries = data.result.geoJsonClusters;
            this.assignmentService.servicesGeometries = data.result.geoJsonServices;
            if(!environment.production) console.log("data.result", data.result);
            
            if(!environment.production) console.log("regionsGeometries", this.assignmentService.regionsGeometries);
            if(!environment.production) console.log("zonesGeometries", this.assignmentService.zonesGeometries);
            if(!environment.production) console.log("clustersGeometries", this.assignmentService.clustersGeometries);
            if(!environment.production) console.log("geoJsonServices", this.assignmentService.servicesGeometries);
            this.assignmentService.SetAssigning(true);
          }else{
            this.notifyService.MessageError("Problema al asignar los servicios, comuniquese con el administrador");
          }
        },
        error: (error) => {
          // TODO marca para complete despues
          console.error('Error al obtener la ultima asignacion de ingenieros', error);
          this.notifyService.MessageError("Error al obtener datos de asignación");
        }
      });
      }
    });
  }


  calculateRestrictions(){
    this.allowedParts = this.mapRestrictionsService.allowedParts$.value;
    this.isTrazabilityAllowed =  this.allowedParts?.allowedFeaturesDetailsPanel?.includes(this.detailsPanelAllowanceEnum.routeTrazability);
  }

}
